import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-api-tear-sheet',
  templateUrl: 'api-tear-sheet.html',
})
export class ApiTearSheetPage {

	loading: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController) {
  }

}



// WEBPACK FOOTER //
// ./src/pages/api-tear-sheet/api-tear-sheet.ts